import React from "react";
import Autocomplete, { AutocompleteProps } from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

// A value chosen from a list the backend supplies: the outlined Autocomplete with a floating label.
// `error`/`helperText` let a form wrapper surface its own validation without knowing how the field
// is drawn.
function OptionSelect<Option, Multiple extends boolean | undefined = false>({
  label,
  error,
  helperText,
  ...autocompleteProps
}: {
  label: string;
  error?: boolean;
  helperText?: React.ReactNode;
} & Omit<AutocompleteProps<Option, Multiple, any, false>, "renderInput">) {
  return (
    <Autocomplete
      {...autocompleteProps}
      disableCloseOnSelect={autocompleteProps.multiple}
      filterSelectedOptions
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
}

export default OptionSelect;
